import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getLanguage } from '@/controller/lang';

const someDefaultLang = [
    { locale: 'en', name: 'English' },
    { locale: 'zh-CN', name: '简体中文' },
];

const useAllLang = () => {
    const { i18n } = useTranslation('common');
    const [allLangs, setAllLangs] = useState(someDefaultLang);
    const [langName, setLangName] = useState({});

    useEffect(() => {
        const getlang = async () => {
            // try {
            //   const ret = await getLanguage();
            //   if (ret.status === 200) {
            //     if (Array.isArray(ret.data?.data)) {
            //       setAllLangs(ret.data.data);
            //     }
            //   }
            // } catch (e) {
            //   //
            // }
        };
        getlang();
    }, []);

    useEffect(() => {
        let ln = {};
        allLangs.forEach((e, i) => {
            ln[e.locale] = e.name;
        });
        setLangName(ln);
    }, [allLangs]);

    const changeLanguage = (l) => {
        i18n.changeLanguage(l);
        localStorage.setItem('lang', l);
    };

    return [allLangs, langName, changeLanguage];
};

export default useAllLang;
